import React, { FunctionComponent } from 'react';
import { RecruitmentImage } from '../../../types/recruitments';
import { CoverThumbsSliderShow } from '../../molecules/coverThumbsSliderShow';

type Props = {
  images: RecruitmentImage[];
  recruitmentTitle: string;
  isScouted: boolean;
  isApplied: boolean;
  isNew: boolean;
  regularEmployee: boolean;
  noimage: string;
};

export const Presentation: FunctionComponent<Props> = (props) => {
  return <CoverThumbsSliderShow {...props} />;
};
